import { getEmbedded } from "../../util/utils";

const HeaderLayout = (props) => {
  const isEmbedded = getEmbedded();
  if(isEmbedded){
    return null;
  }
  return (
    <header
      className="header"
      id="header"
    >
      {props.children}
    </header>
  );
};

export default HeaderLayout;
